import { useEffect } from 'react';

/**
 * Component to load KARTE/Wicle script dynamically from environment variable
 * Only need to import this component into App.jsx
 */
const WicleLoader = () => {
  useEffect(() => {
    // Get KARTE API Key/Tracking ID from environment variable
    // Note: This is the API Key to load the script, not the Project ID on the dashboard
    const karteApiKey = process.env.REACT_APP_WICLE_API_KEY;

    // If there is no API key, do not load the script (dev environment may not need)
    if (!karteApiKey) {
      return;
    }

    // Check if script is already loaded (avoid loading twice)
    if (window.krt) {
      return;
    }

    console.log('[WICLE] Loading KARTE script...');

    // Load KARTE initialization script
    // eslint-disable-next-line no-unused-expressions
    !(function (n) {
      if (!window[n]) {
        var o = (window[n] = function () {
          var n = [].slice.call(arguments);
          return o.x ? o.x.apply(0, n) : o.q.push(n);
        });
        o.q = [];
        o.i = Date.now();
        o.allow = function () {
          o.o = 'allow';
        };
        o.deny = function () {
          o.o = 'deny';
        };
      }
    })('krt');

    // Load KARTE edge script with API Key
    const script = document.createElement('script');
    script.src = `https://cdn-edge.karte.io/${karteApiKey}/edge.js`;
    script.async = true;
    script.onload = () => {
      console.log('[WICLE] KARTE script loaded successfully');
    };
    script.onerror = () => {
      console.error('[WICLE] Failed to load KARTE script');
    };

    document.head.appendChild(script);

    // Cleanup when component unmount
    return () => {
      // Do not remove script because it may still be in use
    };
  }, []);

  // This component does not render anything
  return null;
};

export default WicleLoader;
